<template>
  <div>
    <section-title class="mt-3" content="Datos de Firma" :has-line="true" />
    <div>
      <span class="my-3 color-gray-6 font-16 text-justify">
        Municipio:
      </span>
    </div>
    <div class="col-3 py-3 px-1">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-drop-down
          id="state"
          ref="municipalitySignatureRef"
          v-model="contractInformationModel.municipalitySignature"
          :clearable="false"
          custom-error-msg="El municpio es requerido."
          :error="errors[0]"
          fieldkey="id"
          fieldname="name"
          :options="stateOptions"
          placeholder="Seleccione"
        />
      </validation-provider>
    </div>
    <div class="col-12 row">
      <div class="col-md-9 my-3 color-gray-6 font-16 text-justify">
        <span>
          ¿Cuál será el mecanismo que se estará utilizando para firmar el
          contrato de servicios?
        </span>
      </div>
      <div class="col-md-3 d-flex justify-content-end custom-radio-container">
        <radio-button
          ref="radioButtonRef"
          v-model="contractInformation.isElectronicsSignature"
          :change-event="onChange"
          class="radio-button-container"
          :question-lists="options"
        />
      </div>
    </div>
    <div v-if="showSignatures" class="col-12 row">
      <signatures-contractor
        ref="SignaturesContractorRef"
        :company-id="companyId"
        :contract-id="contractId"
        :contract-info="contractInfo"
        :is-electronic-sign="isElectronicSign"
        :signatures-updated="signaturesUpdated"
        :student-sie-id="contractInfo?.studentSieId"
        @on-refresh-contractor-info="
          $emit('on-refresh-contractor-info', $event)
        "
        @update-signatures="updateSignatures"
      />
      <signatures-provider
        ref="SignaturesProviderRef"
        :company-id="companyId"
        :contract-id="contractId"
        :provider-selected="providerSelected"
        :request-service-type-id="this.requestServiceTypeId"
        @update-signatures-provider="updateSignaturesProvider"
      />
      <signatures-teacher
        v-if="canShowSignaturesTeacher"
        ref="SignaturesTeacherRef"
        :academic-year-id="contractInfo?.academicYearId"
        :contract-id="contractId"
        :contract-information-model="contractInformationModel"
        :contract-status-id="contractInfo?.contractStatusId"
        :signatures-updated-teacher="signaturesUpdatedTeacher"
        :student-sie-id="contractInfo?.studentSieId"
        :teachers-updated="teachersUpdated"
        @update-signatures-teacher="updateSignaturesTeacher"
      />
      <signature-director
        v-if="canShowSignaturesTeacher"
        ref="SignaturesDirectorRef"
        :company-id="companyId"
        :contract-id="contractId"
        :request-service-type-id="requestServiceTypeId"
        :signatures-updated-director="signaturesUpdatedDirector"
        :student-school-id="contractInformationModel.StudentSchoolId"
        @update-signatures-director="updateSignaturesDirector"
      />
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import { getMunicipalities as _getMunicipalities } from '@/services/common/location.api';
import CustomDropDown from 'custom-drop-down';
import RadioButton from '@/components/common/CustomRadioButton';
import SignaturesProvider from './SignaturesProvider.vue';
import SignaturesContractor from './SignaturesContractor.vue';
import SignaturesTeacher from './SignaturesTeacher.vue';
import { getByParameterName } from '@/services/common/sysparameter.api';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import SignatureDirector from './SignatureDirector.vue';

export default {
  name: 'ContractSignature',
  components: {
    SectionTitle,
    CustomDropDown,
    RadioButton,
    SignaturesProvider,
    SignaturesContractor,
    SignaturesTeacher,
    SignatureDirector,
  },
  async mounted() {
    await this.getMunicipality();
    await this.getElectronicSignatureSysParameter();
  },
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    companyId: {
      type: Number,
      default: 0,
      required: false,
    },
    contractInfo: {
      type: Object,
      default: () => {},
    },
    contractInformationModel: {
      type: Object,
      default: () => {},
    },
    signaturesUpdated: {
      type: Array,
      default: () => [],
    },
    studentSieId: {
      type: Number,
      default: 0,
    },
    contractInformation: {
      type: Object,
      default: () => {},
    },
    isElectronic: {
      type: Boolean,
      default: false,
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    signaturesUpdatedTeacher: {
      type: Array,
      default: () => [],
    },
    signaturesUpdatedDirector: {
      type: Array,
      default: () => [],
    },
    teachersUpdated: {
      type: Array,
      default: () => [],
    },
    providerSelected: {
      type: String,
      default: () => null,
      required: false,
    },
  },
  data: () => ({
    stateOptions: [],
    signatures: [],
    signaturesTeacher: [],
    signaturesDirector: [],
    signaturesProvider: [],
    showSignatures: false,
    isElectronicSign: false,
    isElectronicSignatureEnabled: null,
  }),
  computed: {
    options() {
      return {
        options: [
          {
            id: true,
            label: 'Electrónica',
            check:
              this.contractInformationModel?.isElectronicsSignature === true,
            disabled: false,
          },
          {
            id: false,
            label: 'Manuscrito',
            check:
              this.contractInformationModel?.isElectronicsSignature === false,
            disabled: false,
          },
        ],
      };
    },
    canShowSignaturesTeacher() {
      return this.contractInfo.requestServiceTypeId === servicesTypes.Assistant;
    },
  },
  methods: {
    async getMunicipality() {
      this.stateOptions = (await _getMunicipalities()).data;
    },
    onChange(item) {
      this.contractInformationModel.isElectronicsSignature = item.id;
      this.showSignatures = true;
      this.isElectronicSign = item.id;

      this.$nextTick(() => {
        if (this.isElectronicSign) {
          if (this.$refs.SignaturesContractorRef) {
            this.$refs.SignaturesContractorRef.getParentsSignatures();
          }
        } else {
          if (this.$refs.SignaturesContractorRef) {
            this.$refs.SignaturesContractorRef.getSignatures();
          }
        }
      });
    },
    updateSignatures(signatures) {
      this.signatures = signatures;
      this.$emit('update-signatures', this.signatures);
    },
    async canCreateContractByDigitalSignature() {
      if (this.contractInfo.requestServiceTypeId === servicesTypes.Therapy) {
        const { data } = await getByParameterName(
          'RP_CreateTherapyContractByDigitalSignature'
        );
        if (data) {
          return data.value.toLowerCase() === 'true';
        }
      }
      if (this.contractInfo.requestServiceTypeId === servicesTypes.Evaluation) {
        const { data } = await getByParameterName(
          'RP_CreateEvaluationContractByDigitalSignature'
        );
        if (data) {
          return data.value.toLowerCase() === 'true';
        }
      }
      if (this.contractInfo.requestServiceTypeId === servicesTypes.Assistant) {
        const { data } = await getByParameterName(
          'RP_CreateAssistantContractByDigitalSignature'
        );
        if (data) {
          return data.value.toLowerCase() === 'true';
        }
      }
      return false;
    },
    updateSignaturesTeacher(signaturesTeacher) {
      this.signaturesTeacher = signaturesTeacher;
      this.$emit('update-signatures-teacher', this.signaturesTeacher);
    },
    updateSignaturesDirector(signaturesDirector) {
      this.signaturesDirector = signaturesDirector;
      this.$emit('update-signatures-director', this.signaturesDirector);
    },
    updateSignaturesProvider(signaturesProvider) {
      this.signaturesProvider = signaturesProvider;
      this.$emit('update-signatures-provider', this.signaturesProvider);
    },
    async getElectronicSignatureSysParameter() {
      const { data } = await getByParameterName(
        'RPProviderElectronicSignatureEnabled'
      );
      if (data) {
        let canCreate = await this.canCreateContractByDigitalSignature();
        this.isElectronicSignatureEnabled =
          data.value.toLowerCase() === 'true' && canCreate === true;
      }
    },
  },
  watch: {
    isElectronicSignatureEnabled: {
      immediate: false,
      handler: function(value) {
        if (value === false) {
          this.options.options = this.options.options.filter(
            (option) => option.id !== true
          );
        }
      },
    },
    contractInformation: {
      immediate: true,
      handler: function(value) {
        this.contractInformationModel.municipalitySignature =
          value?.municipalitySignature;
        this.$refs.municipalitySignatureRef?.updateValue(
          this.contractInformationModel.municipalitySignature
        );

        this.$emit('input', this.contractInformationModel);

        if (this.contractInformation?.isElectronicsSignature !== null) {
          if (this.contractInformation?.isElectronicsSignature === true) {
            this.showSignatures = true;
            this.isElectronicSign = true;
            this.options.options[0].check = true;
            this.onChange({
              id: true,
              check: true,
              disabled: false,
              label: 'Electrónica',
            });
          }
          if (this.contractInformation?.isElectronicsSignature === false) {
            this.showSignatures = true;
            this.isElectronicSign = false;
            this.options.options[1].check = true;
            this.onChange({
              id: false,
              check: true,
              disabled: false,
              label: 'Manuscrito',
            });
          }
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
</style>
